export default "__VITE_ASSET__aqmh8IUd__"